module.exports = __webpack_public_path__ + "static/img/game-logo-flow.90927e9.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/build922/assets/image/gamelogo/game-logo-flow.png
// module id = XhzZ
// module chunks = 0 1 2 3 4 5 6